;
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });



;
  // FF v13 (2026-06-13): Drawer "Search 900+ products..." pill (#search_link).
  // The pill is an <a href="/search"> so it still works with JS off. With JS we intercept
  // the click so it opens the predictive-search drawer (#search_mobile) instead of
  // navigating to /search.
  //
  // global.min.js already binds a TOGGLE handler to #search_link (open-if-closed /
  // close-if-open) that opens the drawer + focuses the input. This inline handler runs
  // FIRST (parse-time) and must NOT also open the drawer, or the two handlers fight on the
  // same click (mine opens -> global toggles it shut -> net no-op). So here we only:
  //   1. preventDefault (kill the /search navigation),
  //   2. close the hamburger menu drawer so the search popup isn't hidden behind it,
  //   3. on the next tick, if NOTHING opened the drawer (i.e. global.js was absent),
  //      open it + focus the input ourselves as a fallback.
  // This keeps the popup opening in both worlds without double-toggling.
  (function () {
    var searchLink = document.getElementById('search_link');
    if (!searchLink || searchLink.dataset.ffSearchBound) return;
    searchLink.dataset.ffSearchBound = '1';
    searchLink.addEventListener('click', function (event) {
      var searchMobile = document.getElementById('search_mobile');
      if (!searchMobile) return; // no popup in DOM -> allow /search fallback navigation
      event.preventDefault();
      var menuDrawer = document.getElementById('Details-menu-drawer-container');
      if (menuDrawer) {
        menuDrawer.classList.remove('menu-opening');
        menuDrawer.removeAttribute('open');
        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
      }
      // Fallback only: if no other handler opened the drawer this tick, open it ourselves.
      setTimeout(function () {
        if (searchMobile.hasAttribute('open')) return; // global.js handled it
        searchMobile.setAttribute('open', 'open');
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
        var searchInput = document.getElementById('Search-In-Modal');
        if (searchInput) {
          try { searchInput.focus({ preventScroll: true }); } catch (e) { searchInput.focus(); }
        }
      }, 0);
    });
  })();

;
  // FF (2026-06-25) [ff-mobile-search-scroll-fix]: SAFETY NET for the MOBILE search
  // trigger (the magnifier in .header__icons -> <details id="search_mobile">).
  //
  // BUG: once the page was scrolled (sticky header goes position:fixed) tapping the
  // mobile search icon did nothing; it only opened when at the very top. DetailsModal
  // (details-modal.min.js) binds the summary's click and toggles the popup open, but
  // in the sticky/fixed state a high-z page layer could swallow the tap, or a stray
  // body-click could immediately re-close it -> net no-op.
  //
  // This handler runs in addition to DetailsModal WITHOUT double-toggling: it only
  // acts on the next tick, and ONLY if the popup is still closed (i.e. DetailsModal
  // failed to open it this tap). It then force-opens + focuses the input, mirroring
  // the #search_link fallback above. If DetailsModal already opened it, we no-op.
  (function () {
    var details = document.getElementById('search_mobile');
    if (!details || details.dataset.ffMobileSearchBound) return;
    var summary = details.querySelector('summary');
    if (!summary) return;
    details.dataset.ffMobileSearchBound = '1';

    function openAndFocus() {
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', 'open');
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
      }
      var input = details.querySelector('input[type="search"]');
      if (input && document.activeElement !== input) {
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      }
    }

    summary.addEventListener('click', function () {
      // Next tick: if DetailsModal already toggled it OPEN, leave it (it also focuses).
      // If it's still CLOSED, DetailsModal didn't catch this tap (overlay/scroll) ->
      // open + focus ourselves so search works at ANY scroll position.
      setTimeout(function () {
        if (!details.hasAttribute('open')) {
          openAndFocus();
        } else {
          // Opened by DetailsModal but make sure the input actually got focus
          // (focus can be lost under the fixed header on some mobile browsers).
          var input = details.querySelector('input[type="search"]');
          if (input && document.activeElement !== input) {
            try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
          }
        }
      }, 0);
    });
  })();

;
  // FF v15 (2026-06-25) [ff-mobile-search-suggestions]: the mobile search popup now
  // shows the SAME suggested-categories + Best-Sellers products as the desktop
  // dropdown (restored via CSS in the header <style> block). When the shopper starts
  // typing, the predictive-search results render under the input; we then hide the
  // static suggestions panel so the two don't stack/clash, and restore it when the
  // field is cleared. The <predictive-search> custom element flips its `open`
  // attribute on/off as results come and go (see predictive-search.js) -> observe it.
  (function () {
    var details = document.getElementById('search_mobile');
    if (!details || details.dataset.ffSuggToggleBound) return;
    var modal = details.querySelector('.search-modal');
    var ps = details.querySelector('predictive-search');
    if (!modal || !ps) return;
    details.dataset.ffSuggToggleBound = '1';

    function sync() {
      // "typing" = predictive search is open OR loading OR has results
      var active = ps.hasAttribute('open') || ps.hasAttribute('loading') || ps.hasAttribute('results');
      modal.classList.toggle('ff-search-typing', active);
    }
    new MutationObserver(sync).observe(ps, {
      attributes: true,
      attributeFilter: ['open', 'loading', 'results'],
    });
    sync();
  })();

;
  /* FF (2026-06-29) [ff-mobile-search-unlock]: guarantee the search close releases the
     scroll lock so the page never stays frozen after closing search. */
  (function(){
    function unlock(){
      document.body.style.overflow=''; document.documentElement.style.overflow='';
      Array.prototype.slice.call(document.body.classList).forEach(function(c){
        if(/overflow-hidden/.test(c)){ document.body.classList.remove(c); }
      });
    }
    document.querySelectorAll('.header__search--mobile-bar details, details#search_mobile').forEach(function(d){
      d.addEventListener('toggle', function(){ document.body.classList.toggle('ff-search-open', d.open); if(!d.open){ setTimeout(unlock, 30); } });
    });
    document.addEventListener('click', function(e){
      if(e.target.closest && e.target.closest('.header__search--mobile-bar [aria-label=\"Close\"], .header__search--mobile-bar .modal__close-button')){ setTimeout(unlock, 60); }
    });
  })();
